module.exports = __webpack_public_path__ + "img/bicc_jumbotron.7a370c81.png";